<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">Configuration</div>

  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button
        class="nav-link active"
        id="nav-pkgConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#packageConfig"
        type="button"
        role="tab"
        aria-controls="packageConfig"
        aria-selected="true"
        (click)="getPkgConfig()"
      >
        <i class="fa fa-suitcase" aria-hidden="true"></i> Package Configuration
      </button>
      <button
        class="nav-link"
        id="nav-rangeConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#rangeConfig"
        type="button"
        role="tab"
        aria-controls="rangeConfig"
        aria-selected="true"
        (click)="getAllRange()"
      >
        <i class="fa fa-fa fa-sliders-h" aria-hidden="true"></i> Range
      </button>
      <button
        class="nav-link"
        id="nav-coupanConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#coupanConfig"
        type="button"
        role="tab"
        aria-controls="coupanConfig"
        aria-selected="true"
        (click)="getCoupanConfig()"
      >
        <i class="fa fa-fa fa-gift" aria-hidden="true"></i> Coupons
      </button>
      <button
        class="nav-link"
        id="nav-packerMoverConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#packerMoverConfig"
        type="button"
        role="tab"
        aria-controls="packerMoverConfig"
        aria-selected="false"
        (click)="getPackerMoverConfig()"
      >
        <i class="fa fa-briefcase" aria-hidden="true"></i> Packers Movers
        Configuration
      </button>
      <button
        class="nav-link"
        id="nav-applicationConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#applicationConfig"
        type="button"
        role="tab"
        aria-controls="applicationConfig"
        aria-selected="false"
        (click)="getApplicationConfig()"
      >
        <i class="fa fa-cogs" aria-hidden="true"></i> Application Configuration
      </button>
      <button
        class="nav-link"
        id="nav-qrConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#qrConfig"
        type="button"
        role="tab"
        aria-controls="qrConfig"
        aria-selected="false"
        (click)="qrConfigTable()"
      >
        <i class="fa fa-qrcode" aria-hidden="true"></i> QR Configuration
      </button>
    </div>
  </nav>

  <!-- Tabs -->
  <div class="tab-content" id="nav-tabContent">
    <!-- package Config Tab -->
    <div
      class="tab-pane fade show active"
      id="packageConfig"
      role="tabpanel"
      aria-labelledby="packageConfig-tab"
      *ngIf="viewPackageConfig"
    >
      <!-- <div class="justify-content-center align-items-center m-5"> -->
      <div class="table-responsive responsive-width mx-auto">
        <table
          class="table table-striped table-bordered border-dark table-hover mt-5 align-items-center"
        >
          <thead>
            <tr class="text-center">
              <th scope="col">
                <h5 class="font-weight-B">Package Configuration Items</h5>
              </th>

              <th scope="col">
                <h5 class="font-weight-B">Amounts / GST</h5>
              </th>
            </tr>
          </thead>
          <tbody class="font-weight-B">
            <tr>
              <td>Helper Amount</td>
              <td><i class="fa fa-inr"></i> {{ helperAmount }}</td>
            </tr>
            <tr>
              <td>Convenience Fee</td>
              <td><i class="fa fa-inr"></i> {{ convenience }}</td>
            </tr>
            <tr>
              <td>Coupon Amount</td>
              <td><i class="fa fa-inr"></i> {{ couponAmount }}</td>
            </tr>
            <tr>
              <td>Commission Per Trip</td>
              <td><i class="fa fa-inr"></i> {{ commission }}</td>
            </tr>
            <tr>
              <td>Trip Fare GST</td>
              <td>{{ tripFareGST }}%</td>
            </tr>
            <tr>
              <td>Helper GST</td>
              <td>{{ helperGST }}%</td>
            </tr>
            <tr>
              <td>Commission Fee GST</td>
              <td>{{ commissionGST }}%</td>
            </tr>
            <tr>
              <td>Convenience Fee GST</td>
              <td>{{ convenienceGST }}%</td>
            </tr>
            <tr>
              <td>Helper TDS Percent</td>
              <td>{{ helperTDSPercent }}%</td>
            </tr>
            <tr>
              <td>Driver TDS Percent</td>
              <td>{{ driverTDSPercent }}%</td>
            </tr>
            <tr>
              <td>Distance for Trip Notification</td>
              <td>{{ distanceForTripNotification }}KM</td>
            </tr>
            <tr>
              <td>Mininmum Distance For Trip</td>
              <td>{{ minimumDistanceForTrip }}KM</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center mb-5">
          <div class="col-12 col-md-6 col-lg-5">
            <button
              class="btn btn-primary w-100"
              (click)="editPackageConfig(editPkgConfig)"
            >
              Edit Package Configuration
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Range Config Tab -->
    <div
      class="table-responsive"
      id="rangeConfig"
      role="tabpanel"
      aria-labelledby="rangeConfig-tab"
      *ngIf="viewRange"
    >
      <table
        class="align-middle mb-0 table table-borderless table-striped table-hover"
        id="excel-table"
      >
        <thead>
          <tr>
            <!-- <th class="w-15">Id</th> -->
            <th>Minimum Distance</th>
            <th>Miximum Distance</th>
            <th>Range</th>
            <th>Created On</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of allRanges">
            <!-- <td class="w-15">
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ data._id }}</div>
                  </div>
                </div>
              </div>
            </td> -->

            <td class="w-15">
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ data.min }} KM</div>
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ data.max }} KM</div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">
                      {{ data.name }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ data.createdOn }}</div>
                  </div>
                </div>
              </div>
            </td>

            <td class="text-end">
              <div class="dropdown">
                <button
                  class="btn btn-info dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Action
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a class="dropdown-item" (click)="editRange(editData, data)"
                      >Edit <i class="fa fa-pencil"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Coupan Config Tab -->
    <div
      class="table-responsive"
      id="coupanConfig"
      role="tabpanel"
      aria-labelledby="coupanConfig-tab"
      *ngIf="viewCoupan"
    >
      <table
        class="align-middle mb-0 table table-borderless table-striped table-hover"
        id="excel-table"
      >
        <thead>
          <tr>
            <!-- <th class="w-15">Id</th> -->
            <th>Coupon Code</th>
            <th>Coupon Amount</th>
            <th>Expiry</th>
            <th>Created On</th>
            <th>Activation Status</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of coupanData">
            <td class="w-15">
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">
                      {{ data.code }}
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ data.amount }}</div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">
                      {{ data.expiry }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">
                      {{ data.createdOn | date : "dd MMM yyyy hh:mm a" }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">
                      <label class="switch">
                        <input
                          type="checkbox"
                          (ngModelChange)="
                            updateCoupanActivationStatus($event, data)
                          "
                          [(ngModel)]="data.isActive"
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td class="text-end">
              <div class="dropdown">
                <button
                  class="btn btn-info dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Action
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a
                      class="dropdown-item"
                      (click)="editCoupan(editCoupanData, data)"
                      >Edit <i class="fa fa-pencil"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Packers Movers Config Tab -->
    <div
      class="tab-pane fade show active"
      id="packerMoverConfig"
      role="tabpanel"
      aria-labelledby="packerMoverConfig-tab"
      *ngIf="viewPackerMoverConfig"
    >
      <div
        class="justify-content-center align-items-center m-5 table-responsive responsive-width mx-auto"
      >
        <!-- <div class="table-responsive"> -->
        <table
          class="table table-striped table-bordered border-dark table-hover align-items-center"
        >
          <thead class="font-weight-B">
            <tr class="text-center">
              <th scope="col">
                <h5 class="font-weight-B">
                  Packers & Movers Configuration Items
                </h5>
              </th>

              <th scope="col"><h5 class="font-weight-B">Amounts</h5></th>
            </tr>
          </thead>
          <tbody class="font-weight-B">
            <tr>
              <td>Packers Movers Lite Amount</td>
              <td><i class="fa fa-inr"></i> {{ packersMoversLitePrice }}</td>
            </tr>
            <tr>
              <td>Packers Movers Standard Amount</td>
              <td><i class="fa fa-inr"></i> {{ packersMoversLiteStandard }}</td>
            </tr>
            <tr>
              <td>Packers Movers Premium Amount</td>
              <td><i class="fa fa-inr"></i> {{ packersMoversLitePremium }}</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center mb-5">
          <div class="col-12 col-md-6 col-lg-5">
            <button
              class="btn btn-primary w-100"
              (click)="editPackageConfig(editPackerMoverConfig)"
            >
              Edit Configuration
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Application Config Tab -->
    <div
      class="tab-pane fade show active"
      id="applicationConfig"
      role="tabpanel"
      aria-labelledby="applicationConfig-tab"
      *ngIf="viewApplicationConfig"
    >
      <div
        class="justify-content-center align-items-center m-5"
        *ngIf="viewImgs"
      >
        <div class="text-center" *ngIf="viewUserIg">
          <img
            src="{{ userImage }}"
            style="height: 70%; width: 50%"
            alt="img"
          />
          <h6 class="font-weight-B mt-1">User Updated Image</h6>
        </div>
        <div class="text-center" *ngIf="viewDrIg">
          <img
            src="{{ driverImg }}"
            style="height: 70%; width: 50%"
            alt="img"
          />
          <h6 class="font-weight-B mt-1">Driver Updated Image</h6>
        </div>
      </div>

      <div
        class="justify-content-center align-items-center mt-5 table-responsive responsive-width mx-auto"
      >
        <table
          class="table table-striped table-bordered border-dark table-hover align-items-center"
        >
          <thead class="font-weight-B">
            <tr class="text-center">
              <th scope="col">
                <h5 class="font-weight-B">Application Configuration Items</h5>
              </th>

              <th scope="col"><h5 class="font-weight-B">Details</h5></th>
            </tr>
          </thead>
          <tbody class="font-weight-B">
            <tr>
              <td>Driver Wallet Minimum Amount</td>
              <td><i class="fa fa-inr"></i> {{ driverWalletMinimumAmount }}</td>
            </tr>
            <tr>
              <td>Driver Minimum Amount Message</td>
              <td>{{ driverMinimumAmountMessage }}</td>
            </tr>
            <tr>
              <td>Driver Set Alert Days</td>
              <td>{{ driverAlertDays }}</td>
            </tr>
               <tr>
              <td>User Set Alert Days</td>
              <td>{{ userAlertDays }}</td>
            </tr>
            <tr>
              <td>AI Load user number access </td>
              <td>{{ aiLoadNumberAccess ? "Yes" : "No" }}</td>
            </tr>
             <tr>
              <td>Is Common Phone and email OTP</td>
              <td>{{ isCommonOTP ? "Yes" : "No" }}</td>
            </tr>
            <tr>
              <td>Mobile No Contact Us</td>
              <td>{{ mobileNoContactUs }}</td>
            </tr>
            <tr>
              <td>Email Id Help</td>
              <td>{{ emailIdHelp }}</td>
            </tr>
            <tr>
              <td>Splash Screen Time (<span>Sec</span>)</td>
              <td>{{ splashScreenTime }}</td>
            </tr>
            <tr>
              <td>Helpline Number</td>
              <td>{{ helpLineNo }}</td>
            </tr>
            <tr>
              <td>User App Version</td>
              <td>{{ userAppVersion }}</td>
            </tr>
            <tr>
              <td>Driver App Version</td>
              <td>{{ driverAppVersion }}</td>
            </tr>
            <tr>
              <td>User App Updates</td>
              <td>{{ userAppUpdates }}</td>
            </tr>
            <tr>
              <td>Driver App Update</td>
              <td>{{ driverAppUpdates }}</td>
            </tr>
            <tr>
              <td>User App Image</td>
              <td>
                <a
                  class="text-primary"
                  style="cursor: pointer"
                  (click)="viewUserImg()"
                  ><u>view</u>
                </a>
              </td>
            </tr>
            <tr>
              <td>Driver App Image</td>
              <td>
                <a
                  class="text-primary"
                  style="cursor: pointer"
                  (click)="viewDrImg()"
                  ><u>view</u>
                </a>
              </td>
            </tr>
            <tr>
              <td>Bill Details Visible</td>
              <td>
                {{ isBillDetails ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <td>Helper Active Status</td>
              <td>
                {{ isHelperActive ? "Active" : "Inactive" }}
              </td>
            </tr>
            <!-- <tr>
              <td>Online Pay</td>
              <td>
                {{ isOnlinePay ? 'Enable' : 'Disable' }}
              </td>
            </tr>      
            <tr>
              <td>Pay On Delivery</td>
              <td>
                {{ isPayOnDelivery ? 'Enable' : 'Disable' }}
              </td>
            </tr>    -->
          </tbody>
        </table>
        <div class="d-flex justify-content-center mb-5">
          <div class="col-12 col-md-6 col-lg-5">
            <button
              class="btn btn-primary w-100"
              (click)="editPackageConfig(editApplicationConfig)"
            >
              Edit Configuration
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- QR Config Tab -->
    <div
      class="tab-pane fade show active"
      id="qrConfig"
      role="tabpanel"
      aria-labelledby="qrConfig-tab"
      *ngIf="viewQrConfig"
    >
      <div
        class="justify-content-center align-items-center m-5 table-responsive responsive-width mx-auto"
      >
        <table
          class="table table-striped table-bordered border-dark table-hover w-50 mx-auto align-items-center"
        >
          <thead class="font-weight-B">
            <tr class="text-center">
              <th scope="col">
                <h5 class="font-weight-B">QR Configuration Items</h5>
              </th>

              <th scope="col"><h5 class="font-weight-B">Details</h5></th>
            </tr>
          </thead>
          <tbody class="font-weight-B">
            <tr>
              <td>Mode</td>
              <td>{{ mode }}</td>
            </tr>
            <tr>
              <td>MC</td>
              <td>{{ mc }}</td>
            </tr>
            <tr>
              <td>QR Medium</td>
              <td>{{ qrMedium }}</td>
            </tr>
            <tr>
              <td>TN</td>
              <td>{{ tn }}</td>
            </tr>
            <tr>
              <td>PN</td>
              <td>{{ pn }}</td>
            </tr>
            <tr>
              <td>PA</td>
              <td>{{ pa }}</td>
            </tr>
            <tr>
              <td>Created On</td>
              <td>{{ createdOn }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Update Config Models -->

<!-- update Package Config Model -->

<div class="card-body">
  <ng-template #editPkgConfig let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil"> Edit Package Configuration</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Helper Amount <span>( <i class="fa fa-inr"></i> )</span> :
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperAmount"
            class="form-control"
            placeholder="Helper Amount"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Helper GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperGST"
            class="form-control"
            placeholder="Helper GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Coupan Basic Amount <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="couponAmount"
            class="form-control"
            placeholder="Coupan Basic Amount"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Trip Fare GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="tripFareGST"
            class="form-control"
            placeholder="Trip Fare GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Commission Fee <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="commission"
            placeholder="Commission Fee"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Commission Fee GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="commissionGST"
            class="form-control"
            placeholder="Commission Fee GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Convenience Fee <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="convenience"
            placeholder="Convenience Fee"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Convenience Fee GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="convenienceGST"
            class="form-control"
            placeholder="Commission Fee GST"
          />
        </div>
        <div class="col-md-6"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Min Distance For Trip( <span class="font-weight-B">KM</span> ):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="minimumDistanceForTrip"
            placeholder="Minimum Distance For Trip (KM)"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Notification Distance ( <span class="font-weight-B">KM</span> ):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="distanceForTripNotification"
            class="form-control"
            placeholder="Distance for Notification (KM)"
          />
        </div>
        <!-- <div class="col-md-5">
          <label for=""
            >Helper TDS (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperTDSPercent"
            class="form-control"
            placeholder="Helper TDS"
          />
        </div> -->
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <!-- <div class="col-md-5">
          <label for=""
            >Notification Distance ( <span class="font-weight-B">KM</span> ):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="distanceForTripNotification"
            class="form-control"
            placeholder="Distance for Notification (KM)"
          />
        </div> -->

        <div class="col-md-5">
          <label for=""
            >Helper TDS (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperTDSPercent"
            class="form-control"
            placeholder="Helper TDS"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Driver TDS (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="driverTDSPercent"
            class="form-control"
            placeholder="Helper TDS"
          />
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-10 mt-3"
          (click)="updatePackageConfig()"
          [disabled]="
            helperAmount === null ||
            helperAmount === undefined ||
            helperTDSPercent === null ||
            helperTDSPercent === undefined ||
            helperGST === null ||
            helperGST === undefined ||
            couponAmount === null ||
            couponAmount === undefined ||
            tripFareGST === null ||
            tripFareGST === undefined ||
            commission === null ||
            commission === undefined ||
            commissionGST === null ||
            commissionGST === undefined ||
            convenience === null ||
            convenience === undefined ||
            convenienceGST === null ||
            convenienceGST === undefined ||
            minimumDistanceForTrip === null ||
            minimumDistanceForTrip === undefined ||
            distanceForTripNotification === null ||
            distanceForTripNotification === undefined
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- Update range config model -->

<div class="card-body">
  <ng-template #editData let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil">Update Range</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Minimum Distance (KM): </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="minimumDistance"
            class="form-control"
            placeholder="Minimum Distance"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Maximum Distance (KM): </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="maximumDistance"
            class="form-control"
            placeholder="Maximum Distance"
          />
        </div>
        <div class="col-md-2"></div>
      </div>
      <!-- Validation error message -->
      <div
        class="row"
        *ngIf="
          minimumDistance >= maximumDistance &&
          maximumDistance !== undefined &&
          minimumDistance !== undefined
        "
      >
        <div class="col-md-12 text-center">
          <p class="text-danger small">
            Max Distance Must greater than Min Distance.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Range : </label>
          <input
            type="text"
            min="0"
            [(ngModel)]="range"
            class="form-control"
            placeholder="range"
          />
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-6 mt-3"
          (click)="updateRange()"
          [disabled]="
            minimumDistance === null ||
            minimumDistance === undefined ||
            maximumDistance === null ||
            maximumDistance === undefined ||
            minimumDistance >= maximumDistance ||
            !range
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- Update Coupan Config Model -->
<div class="card-body">
  <ng-template #editCoupanData let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil">Update Coupon</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Coupon Code: </label>
          <input
            type="text"
            [(ngModel)]="coupanDataCoupanCode"
            class="form-control"
            placeholder="Coupon Code"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Coupon Amount: </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="coupanDataAmt"
            class="form-control"
            placeholder="Coupon Amount"
          />
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for="">Coupon Expiry: </label>
          <input
            type="date"
            [(ngModel)]="coupanDataExpiry"
            class="form-control"
            placeholder="Coupon Expiry"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-6 mt-3"
          (click)="updateCoupan()"
          [disabled]="
            !coupanDataCoupanCode ||
            coupanDataAmt === null ||
            coupanDataAmt === undefined ||
            !coupanDataExpiry
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- update Packer Mover Config Model -->

<div class="card-body">
  <ng-template #editPackerMoverConfig let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil">Edit Packers Movers Configuration</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for=""
            >Packers Movers Lite Amount
            <span>( <i class="fa fa-inr"></i> )</span> :
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="packersMoversLitePrice"
            class="form-control"
            placeholder="Packers Movers Lite Amount"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for=""
            >Packers Movers Standard Amount (
            <span class="font-weight-B"> <i class="fa fa-inr"></i> </span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="packersMoversLiteStandard"
            class="form-control"
            placeholder="Packers Movers Standard Amount"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label for=""
            >Packers Movers Premium Amount
            <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="packersMoversLitePremium"
            class="form-control"
            placeholder="Coupon Basic Amount"
          />
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-6 mt-3"
          (click)="updatePackerMoverConfig()"
          [disabled]="
            packersMoversLitePrice === null ||
            packersMoversLitePrice === undefined ||
            packersMoversLiteStandard === null ||
            packersMoversLiteStandard === undefined ||
            packersMoversLitePremium === null ||
            packersMoversLitePremium === undefined
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- update Application Config Model -->

<div class="card-body">
  <ng-template #editApplicationConfig let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil">Edit Application Configuration</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <label for=""
            >Driver Wallet Minimum Amount <i class="fa fa-wallet"></i>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="driverWalletMinimumAmount"
            class="form-control"
            placeholder="Driver Wallet Minimum Amount"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

           <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <label for="">Driver Minimum Amount Message : </label>
          <input
            type="text"
            [(ngModel)]="driverMinimumAmountMessage"
            class="form-control"
            placeholder="Driver Minimum Amount Message"
          />
          <div *ngIf="errorMessage" class="text-danger">
            <small>Message must contain #.</small>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Driver Set Alert Days <i class="fa fa-wallet"></i>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="driverAlertDays"
            class="form-control"
            placeholder="Enter driver set alert days"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >User Set Alert Days <i class="fa fa-wallet"></i>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="userAlertDays"
            class="form-control"
            placeholder="Enter user set alert days"
          />
        </div>
       
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Mobile No Contact Us <i class="fa fa-phone-square"></i>:
          </label>
          <input
            type="text"
            min="0"
            [(ngModel)]="mobileNoContactUs"
            class="form-control"
            placeholder="Mobile No Contact Us"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Email Id Help <span> <i class="fa fa-envelope"></i> </span> :
          </label>
          <input
            type="email"
            min="0"
            [(ngModel)]="emailIdHelp"
            class="form-control"
            placeholder="Email Id Help"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Splash Screen Time (<span>Sec</span>) : </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="splashScreenTime"
            class="form-control"
            placeholder="Splash Screen Time"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Helpline Number <i class="fa fa-phone-square"></i>:
          </label>
          <input
            type="text"
            min="0"
            [(ngModel)]="helpLineNo"
            class="form-control"
            placeholder="Helpline Number"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">User App Version : </label>
          <input
            type="text"
            [(ngModel)]="userAppVersion"
            class="form-control"
            placeholder="User App Version"
          />
        </div>
        <div class="col-md-5">
          <label for="">Driver App Version : </label>
          <input
            type="text"
            [(ngModel)]="driverAppVersion"
            class="form-control"
            placeholder="Driver App Version"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">User App Updates : </label>
          <input
            type="text"
            [(ngModel)]="userAppUpdates"
            class="form-control"
            placeholder="User App Version"
          />
        </div>
        <div class="col-md-5">
          <label for="">Driver App Updates : </label>
          <input
            type="text"
            [(ngModel)]="driverAppUpdates"
            class="form-control"
            placeholder="Driver App Updates"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">User App Update Image : </label>
          <div>
            <input
              type="file"
              (change)="getUpdatedImage($event, 'UserUpdateImg')"
              placeholder="User Update Image"
            />
            <div *ngIf="isUserValidImage == true" class="text-danger">
              Please Select image file
            </div>
            <div *ngIf="isUserImageUploaded == true" class="text-success">
              Image Uploaded Successfully
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="">Driver App Update Image : </label>
          <div>
            <input
              type="file"
              (change)="getUpdatedImage($event, 'DriverUpdateImg')"
              placeholder="Vehicle Image"
            />
            <div *ngIf="isValidImage == true" class="text-danger">
              Please Select image file
            </div>
            <div *ngIf="isImageUploaded == true" class="text-success">
              Image Uploaded Successfully
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""> Bill Details Visibility : </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="billdetailsVisible($event)"
              [(ngModel)]="isBillDetails"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col-md-5">
          <label for=""> Helper Active: </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="heplerActive($event)"
              [(ngModel)]="isHelperActive"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
       <div class="col-md-1"></div>
       <div class="col-md-5">
          <label for=""
            >AI Load user number access :
          </label>
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="aiLoadNumberAccessChanged($event)"
              [(ngModel)]="aiLoadNumberAccess"
            />
            <span class="slider round"></span>
          </label>
        </div>
         <div class="col-md-5">
          <label for=""> Is Common Email & Phone OTP: </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="isCommonOTPChanged($event)"
              [(ngModel)]="isCommonOTP"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col-md-2"></div>
      </div>

      <!-- <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""> Online Payment Method:  </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="OnlinePay($event)"
              [(ngModel)]="isOnlinePay"
            />
            <span class="slider round"></span>
          </label>
          </div>
        <div class="col-md-5">
          <label for=""> Pay On Delivery:  </label> <br />
            <label class="switch">
              <input
                type="checkbox"
                (ngModelChange)="payOnDel($event)"
                [(ngModel)]="isPayOnDelivery"
              />
          <span class="slider round"></span>
          </label>
        </div>
        <div class="col-md-2"></div>
      </div> -->

      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-6 mt-3"
          (click)="checkValidMessage()"
          [disabled]="
            !mobileNoContactUs ||
            !emailIdHelp ||
            splashScreenTime === null ||
            splashScreenTime === undefined ||
            !helpLineNo ||
            driverWalletMinimumAmount === null ||
            driverWalletMinimumAmount === undefined ||
            !driverMinimumAmountMessage ||
            driverAlertDays === null ||
            driverAlertDays === undefined ||  
            userAlertDays === null ||
            userAlertDays === undefined 
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>
